<template src="./General.html"></template>

<script>
import topMenu from "@/components/sites/components/topMenu";
import Pagination from "@/components/components/pagination";
import {createNamespacedHelpers} from "vuex";
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('sites/statistic')

export default {
  name: "Statistic",
  data() {
    return {
      showOverlay: false,
      fromDate: null,
      toDate: null,

      fieldsList: [
        {
          key: 'domain',
          label: 'Домен',
        },
        {
          key: 'lead',
          label: 'Лиды',
        },
        {
          key: 'orderCount',
          label: 'Заказы',
        },
        {
          key: 'requisition',
          label: 'КП',
        },
        {
          key: 'invoiced',
          label: 'Счета',
        },
        {
          key: 'conversion',
          label: 'Конверсия',
        },

        {
          key: 'organicTraffic',
          label: 'Поисковый трафик',
        },
        {
          key: 'directTraffic',
          label: 'Прямой трафик',
        },
        {
          key: 'internalTraffic',
          label: 'Внутренний трафик',
        },
        {
          key: 'adTraffic',
          label: 'Рекламный трафик',
        },
        {
          key: 'referralTraffic',
          label: 'Link трафик',
        },
        {
          key: 'socialTraffic',
          label: 'Социальный трафик',
        },
        {
          key: 'totalTraffic',
          label: 'Общий трафик',
        },
      ],
      dateRange: {}
    }
  },
  components: {
    topMenu,
    Pagination,
    SelfDateRangePicker,
  },
  methods: {
    ...mapActions([
        'GET_DATA',
        'GET_EXTRIMAL_DATE',
    ]),
    goToPage: function (page) {
      this.$store.commit('sites/statistic/CURRENT_PAGE', page)
      this.getData()
    },
    perPage: function (page) {
      this.$store.commit('sites/statistic/PER_PAGE', page)
      this.$store.commit('sites/statistic/CURRENT_PAGE', 1)
      this.getData()
    },
    changeDate: function () {
      if (this.fromDate == this.FROM && this.toDate == this.TO) {
        return
      }
      this.$store.commit('sites/statistic/FROM', this.fromDate)
      this.$store.commit('sites/statistic/TO', this.toDate)
      this.initPageSize()
      this.getData()
    },
    initPageSize: function() {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 495) / 25)
      winHeight = winHeight <= 0 ? 1 : winHeight
      console.log(winHeight)
      this.$store.commit('sites/statistic/PER_PAGE', winHeight)
      this.$store.commit('sites/statistic/CURRENT_PAGE', 1)
    },
    getData: function () {
      if (this.isDateSelected) {
        this.GET_DATA({th: this})
      }
    },
    rangeUpdate: function (val) {
      this.fromDate = val.from
      this.toDate = val.to
      this.changeDate()
    }
  },
  computed: {
    ...mapGetters([
      'DATA',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'SITE_LIST',
      'FROM',
      'TO',
      'MIN_DATE',
      'MAX_DATE',
    ]),
    tableFieldsList: function () {
      let result = []
      for (let key in this.fieldsList) {
        result.push({
          key: this.fieldsList[key].key,
          label: this.fieldsList[key].label,
          sortable: false
        })
      }

      return result
    },
    isDateSelected: function () {
      return this.fromDate != null && this.toDate != null
    },
    firstSiteId: function () {
      return this.DATA[0]?.id?.toString() ?? '';
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return;
    }

    if (this.MIN_DATE == null || this.MAX_DATE == null) {
      this.GET_EXTRIMAL_DATE({th: this})
    }
  },
  created() {
    if (this.FROM != null) {
      this.fromDate = this.FROM
      this.dateRange.startDate = new Date(this.fromDate)
      console.log(this.dateRange.startDate)
    }
    if (this.TO != null) {
      this.toDate = this.TO
      this.dateRange.endDate = new Date(this.toDate)
      console.log(this.dateRange.endDate)
    }
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
</style>